import functionUncurryThis from './function-uncurry-this.mjs';
import isCallable$1 from './is-callable.mjs';
import './shared-store.mjs';
import { s as sharedStore } from '../../../../../../_virtual/shared-store.mjs';

var uncurryThis = functionUncurryThis;
var isCallable = isCallable$1;
var store = sharedStore.exports;

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource = store.inspectSource;

export { inspectSource as default };
